import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

import {athubAxios} from "@/util/athub-axios"
import {addParamsToUrl} from "@/util";

const orgTree = new RestResource({server: ORGANIZATION_SERVER, resource: 'org/tree'});

orgTree.findTree = (parentId, orgTypes, athubConfig) => {
    return athubAxios.get(addParamsToUrl([orgTree.server, orgTree.resource].join('/'), {
        parentId: parentId,
        orgTypes: orgTypes,
    }), athubConfig);
};

export default orgTree;